import { SiniestroItem } from '../types/siniestros.types';

export interface CeldaEmpresa {
    nombre: string;
    cuit?: string;
}

// Celdas "Contrato" y "Organismo" del listado de Siniestros para el Preventor (SMP-484): nombre
// arriba y CUIT abajo, con el mismo criterio que la columna Contrato del resto de los roles
// ("—" si falta el dato de arriba).
export const getContratoOrganismoPreventor = (
    item: SiniestroItem
): { contrato: CeldaEmpresa; organismo: CeldaEmpresa } => ({
    contrato: { nombre: item?.nombreContrato || '—', cuit: item?.cuitContrato },
    organismo: { nombre: item?.nombreOrganismo || '—', cuit: item?.cuitOrganismo }
});
